import Alert from '@mui/material/Alert'
import IconButton from '@mui/material/IconButton'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import Stack from '@mui/material/Stack'

type FeedbackAlertsProps = {
    success: string | null
    error: string | null
    onClearSuccess: () => void
    onClearError: () => void
}

function FeedbackAlerts({ success, error, onClearSuccess, onClearError }: FeedbackAlertsProps) {
    if (!success && !error) return null

    return (
        <Stack spacing={1}>
            {success && (
                <Alert
                    severity="success"
                    action={
                        <IconButton color="success" size="small" onClick={onClearSuccess}>
                            <CloseRoundedIcon />
                        </IconButton>
                    }
                >
                    {success}
                </Alert>
            )}

            {error && (
                <Alert
                    severity="error"
                    action={
                        <IconButton color="error" size="small" onClick={onClearError}>
                            <CloseRoundedIcon />
                        </IconButton>
                    }
                >
                    {error}
                </Alert>
            )}
        </Stack>
    )
}

export default FeedbackAlerts
